import React, { Component }                 from 'react';
import ReactTable                           from 'react-table';
import urlHandler                           from '../../utils/urlHandler';
import perms                                from '../../utils/permissions';
import UserManual                           from '../../styles/docs/FFT_DemoUserGuide.pdf';
import InterestAreasDetailsControl          from './InterestAreasDetailsControl';
import InterestAreasUploadDialog            from './InterestAreasUploadDialog';
import InterestAreasDeleteDialog            from './InterestAreasDeleteDialog';
import history                              from '../../utils/history';

import 'react-table/react-table.css'

class InterestAreasControl extends Component {
    constructor(props){
        super(props);

        this.renderDocuments = this.renderDocuments.bind(this);

        this.onSelectResult = this.onSelectResult.bind(this);
        this.onRowExpanded = this.onRowExpanded.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.onUploadComplete = this.onUploadComplete.bind(this);
        this.onDeleteDoc = this.onDeleteDoc.bind(this);
        this.onDeleteArea = this.onDeleteArea.bind(this);
        this.onDeleteComplete = this.onDeleteComplete.bind(this);

        this.state = {
            iaPermissions: {
                read: false,
                create: false
            },
            selected: null,
            selectedData: null,
            areas: null,
            expandedArea: null,
            expanded: {}
        }
    }

    componentDidMount() {
        const iaPerm = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_INTEREST_AREAS);
        if (!iaPerm){
            history.push('/')
        } else{
            urlHandler.getInterestAreas((result, status) => {
                if (status === 200) {
                    this.setState({
                        read: iaPerm,
                        create : perms.getTaggingModels().length > 0,
                        areas: 'interestAreas' in result ? result['interestAreas'].map((name) => ({ name })) : []
                    });
                } else if (status === 404) {
                    this.setState({
                        read: iaPerm,
                        create : perms.getTaggingModels().length > 0,
                        areas: []
                    });
                } else{
                    this.setState({
                        read: iaPerm,
                        create : perms.getTaggingModels().length > 0,
                    });
                }
            })  
        }
    }

    renderDocuments(row) {

        const columns = [
            {
                Header: 'Actions',
                width: 75,
                accessor: 'id', Cell: (row) => (
                    <span className="fa fa-trash-o" 
                        title="Delete document from interest area" 
                        onClick={(e) => {this.onDeleteDoc(row, e)}}>
                    </span>
                )
            },
            {
                Header: (props) => <span style={{float: 'left'}}>Document</span>,
                accessor: 'documentTitle', Cell: (row) => (
                    <span style={{whiteSpace: 'pre-wrap'}}>{row.original.documentTitle}</span>
                )
            },
            {
                Header: (props) => <span style={{float: 'left'}}>Orientation</span>,
                accessor: 'orientation',
                width: 125
            },
            {
                Header: (props) => <span style={{float: 'left'}}>Tag Model</span>,
                accessor: 'tagModel',
                width: 125
            }
        ];

        var comp = [];
        urlHandler.getInterestArea(row.original.name, (result, status) => {
            if (status === 200) {
                if (result && 'documents' in result) {
                    comp.push(
                        <div key={`sub_${row.index}`} style={{ padding: '10px 10px 10px 25px' }}>
                            <ReactTable
                                className="ia-table -striped -highlight"
                                ref={`doctable_${row.index}`}
                                data = {result['documents']}
                                columns={columns}
                                pageSize={result['documents'].length}
                                minRows={0}
                                getTdProps={this.onSelectResult}
                                showPagination={false}
                            />
                        </div>
                    );
                } else {
                    comp.push(
                        <div key={`sub_${row.index}`} style={{ padding: '10px 10px 10px 30px' }}>
                            No documents found.
                        </div>
                    );                    
                }
            } else if (status === 404) {
                comp.push(
                    <div key={`sub_${row.index}`} style={{ padding: '10px 10px 10px 30px' }}>
                        No documents found.
                    </div>
                  );      
            } else {
                comp.push(
                    <div key={`sub_${row.index}`} style={{ padding: '10px 10px 10px 30px' }}>
                    </div>
                  );      
            }
        }, false)
        return comp;
    }

    onSelectResult(state, rowInfo, column, instance) {
        if (rowInfo) {
            if (rowInfo.index === this.state.selected) {
                return {
                    onClick: (e, handleOriginal) => {
                        this.setState({
                            selected: rowInfo.index,
                            selectedData: rowInfo.original
                        })
                        if (handleOriginal) {
                            handleOriginal();
                        }
                    },
                    style: {
                        background: '#E9ECE0',
                        cursor: 'pointer'
                    }
                };
            } else {
                return {
                    onClick: (e, handleOriginal) => {
                        this.setState({
                            selected: rowInfo.index,
                            selectedData: rowInfo.original
                        })
                        if (handleOriginal) {
                            handleOriginal();
                        }
                    },
                    style: {
                        cursor: 'pointer'
                    }
                };                
            }
    
        } else {
            return {}
        }
    }

    onRowExpanded(newExpanded, index, event) {
        this.setState({
            expanded: {[index[0]]: !this.state.expanded[index[0]]},
            selected: null,
            selectedData: null,
            expandedArea: this.state.areas[index].name
        });
    }

    onUpload() {
        var dlg = this.refs.upload_document;
        dlg.open();
    }

    onDeleteDoc(row, e) {
        e.stopPropagation();
        var dlg = this.refs.delete_document;
        dlg.open(this.state.expandedArea, row.original.documentTitle)
    }

    onDeleteArea(row) {
        var dlg = this.refs.delete_document;
        dlg.open(row.original.name)
    }

    onUploadComplete() {
        if (this.state.iaPermissions.read) {
            urlHandler.getInterestAreas((result, status) => {
                if (status === 200) {
                    const newAreas = 'interestAreas' in result ? result['interestAreas'].map((name) => ({ name })) : [];
                    this.setState({
                        areas: [...newAreas],
                        selected: null,
                        selectedData: null,
                        expandedArea: null,
                        expanded: {}
                    });
                } else if (status === 404) {
                    this.setState({
                        areas: [],
                        selected: null,
                        selectedData: null,
                        expandedArea: null,
                        expanded: {}
                    });
                }
            })                
        }
    }

    onDeleteComplete(name, title) {
        if (this.state.iaPermissions.read) {
            urlHandler.getInterestAreas((result, status) => {
                if (status === 200) {
                    const newAreas = 'interestAreas' in result ? result['interestAreas'].map((name) => ({ name })) : [];
                    this.setState({
                        areas: [...newAreas],
                        selected: null,
                        selectedData: null,
                        expandedArea: null,
                        expanded: {}
                    });
                } else if (status === 404) {
                    this.setState({
                        areas: [],
                        selected: null,
                        selectedData: null,
                        expandedArea: null,
                        expanded: {}
                    });
                }
            })                
        }
    }

    render() {    

        const columns = [
            {
                Header: 'Actions',
                width: 75,
                accessor: 'id', Cell: (row) => (
                    <span className="fa fa-trash-o" 
                        title="Delete interest area" 
                        onClick={(e) => {this.onDeleteArea(row)}}>
                    </span>
                )
            },
            {
                Header: (props) => <span style={{float: 'left'}}>Name</span>,
                accessor: 'name', Cell: (row) => (
                    <div>
                        <span className="fa fa-object-group">&nbsp;&nbsp;</span>{row.original.name}
                    </div>
                )
            }
        ];

        return (
            <div className='iacontrol-wrapper'>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <span>
                                    <h1 className='heading-1' style={{float: 'left'}}>Interest Areas</h1>
                                    <span style={{float: 'right'}}>
                                        <a href={ UserManual } target="__blank" download="FFT_DemoUserManual.pdf"> 
                                            <span className='fa fa-file-pdf-o'>&nbsp;</span> 
                                            User Manual 
                                        </a> 
                                    </span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {(this.state.iaPermissions.read && this.state.areas) &&
                    <div>
                        <div className="iacontrol-results">
                            <span className="iacontrol-list">
                                <div style={{width: '100%', display: 'flex', flex: '1', flexDirection: 'row-reverse', alignItems: 'flex-end'}}>
                                    {this.state.iaPermissions.create &&
                                    <button type="button" 
                                        className="iacontrol-primary-button" 
                                        onClick={this.onUpload}><span className="fa fa-upload">&nbsp;</span>Insert Document
                                    </button> 
                                    }
                                </div>
                                <span>{this.state.areas.length} interest areas.</span>
                                <ReactTable className="ia-table -striped -highlight"
                                    data={ this.state.areas } 
                                    columns={columns}
                                    showPagination={false}
                                    pageSize={this.state.areas.length}
                                    minRows={0}
                                    expanded={this.state.expanded}
                                    onExpandedChange={(newExpanded, index, event) => this.onRowExpanded(newExpanded, index, event)}
                                    SubComponent={(row) => this.renderDocuments(row)}/>
                            </span>

                            {this.state.selectedData &&
                                <div className="iacontrol-details">
                                    <div>
                                        <InterestAreasDetailsControl data={this.state.selectedData}/>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }

                <InterestAreasUploadDialog ref="upload_document" onUpload={this.onUploadComplete}/>
                <InterestAreasDeleteDialog ref="delete_document" onDelete={this.onDeleteComplete}/>
            </div>
        );
    }
}

export default InterestAreasControl;
